import axios from "axios";
import { API_ADMIN_URL, API_BASE_URL, API_KEY } from "../../../config/constants";
import { postRequest } from "../../API";

const getAdminHeaders = () => {
  const token = localStorage.getItem("TOKEN") || sessionStorage.getItem("AGENT-TOKEN");
  return { authToken: token, key: API_KEY };
};

export const getContent = async () => {
  try {
    const response = await axios.get(`${API_ADMIN_URL}raffle-coupon-content/content`, {
      headers: getAdminHeaders(),
    });
    if (response.data?.response?.result) {
      return { status: true, result: response.data.response.result };
    }
    return { status: false, message: response.data?.statusMessage };
  } catch (error) {
    console.log(error);
    return { status: false, message: "Under Maintenance, Please try after some time." };
  }
};

export const saveContent = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}raffle-coupon-content/content`,
      postData: options,
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return { status: true, result: res?.data?.response?.result };
    }
    return { status: false, message: res?.response?.data?.statusMessage };
  } catch (error) {
    console.log(error);
    return { status: false, message: "Under Maintenance, Please try after some time." };
  }
};

export const getPublicContent = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}v1/promocode/raffle-coupon-content`, {
      headers: { key: API_KEY },
    });
    if (response.data?.response?.result) {
      return { status: true, result: response.data.response.result };
    }
    return { status: false, message: "Content not found." };
  } catch (error) {
    console.log(error);
    return { status: false, message: "Under Maintenance, Please try after some time." };
  }
};
